<template lang="pug">
.bloco-alerta-monitoramento-socioambiental
    .alerta-bloco
        .alerta-bloco--icone
            i.mdi.mdi-alert-outline.mdi-36px

        .alerta-bloco--conteudo
            .bloco-links
                ul
                    li
                        a(
                            @click='atualizarTempoAlertas("DIA")',
                            :class='tempoAlertas === "DIA" ? "ativo" : ""'
                        ) Hoje
                    li
                        a(
                            @click='atualizarTempoAlertas("SEMANA")',
                            :class='tempoAlertas === "SEMANA" ? "ativo" : ""'
                        ) Últimos 7 dias
                    li
                        a(
                            @click='atualizarTempoAlertas("MES")',
                            :class='tempoAlertas === "MES" ? "ativo" : ""'
                        ) Últimos 30 dias
                    li
                        a(
                            @click='atualizarTempoAlertas("TODO")',
                            :class='tempoAlertas === "TODO" ? "ativo" : ""'
                        ) Todo período

            .bloco-dados
                .bloco-interno
                    span {{ quantidadeAlertas }}
                    .bloco-interno--texto(v-if='quantidadeAlertas > 1')
                        | Alertas encontrados nos territórios monitorados.
                    .bloco-interno--texto(v-else)
                        | Alerta encontrado nos territórios monitorados.
                    a.bloco-interno--detalhes(
                        @click='abrirModalAlertaDetalhes()'
                    ) Ver Detalhes
    ModalVisualizarDetalhesAlertaSocioambiental(
        :show='mostrarModalDetalhesAlerta',
        @voltar='mostrarModalDetalhesAlerta = false'
    )
</template>

<script>
import AlertaService from '@/services/AlertaService.js';
import ModalVisualizarDetalhesAlertaSocioambiental from './ModalVisualizarDetalhesAlertaSocioambiental.vue';

export default {
    name: 'BlocoAlertaMonitoramentoSocioambiental',

    components: {
        ModalVisualizarDetalhesAlertaSocioambiental
    },

    data() {
        return {
            tempoAlertas: 'DIA',
            totalAlertas: null,
            mostrarModalDetalhesAlerta: false
        };
    },

    computed: {
        quantidadeAlertas() {
            if (!this.totalAlertas) {
                return '-';
            }

            if (this.tempoAlertas === 'DIA') {
                return this.totalAlertas.totalDiario;
            }

            if (this.tempoAlertas === 'SEMANA') {
                return this.totalAlertas.totalSemanal;
            }
            if (this.tempoAlertas === 'TODO') {
                return this.totalAlertas.total;
            }

            return this.totalAlertas.totalMensal;
        }
    },

    async mounted() {
        this.getResumoAlertas();
    },

    methods: {
        getResumoAlertas() {
            AlertaService.getResumoAlertas()
                .then(({ data }) => {
                    this.totalAlertas = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar o resumo dos alertas' +
                            erro
                    });
                });
        },
        atualizarTempoAlertas(tempo) {
            this.tempoAlertas = tempo;
        },
        abrirModalAlertaDetalhes() {
            this.mostrarModalDetalhesAlerta = true;
        }
    }
};
</script>
<style lang="scss">
.bloco-alerta-monitoramento-socioambiental {
    .el-dialog {
        border-radius: 5px;
    }
}

#modal-visualizar-detalhes-alerta-socioambiental
    > div
    > div.el-dialog
    > div.el-dialog__header
    > div.dialog-header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
</style>

<style lang="scss" scoped>
.alerta-bloco {
    background: #ef99181a;
    display: flex;
    justify-content: flex-start;
    border-radius: 8px;
    align-items: center;

    .alerta-bloco--conteudo {
        padding: 5px 8px;

        .bloco-links {
            height: 100%;
            display: flex;
            align-items: center;

            ul {
                margin: 0;
                padding: 0;
                display: flex;

                li {
                    list-style: none;
                    margin-right: 25px;
                    padding: 7px;
                    color: var(--primary);

                    a:not(.ativo) {
                        cursor: pointer;
                        text-decoration: none;
                    }
                    a:hover {
                        cursor: pointer;
                    }
                    a.ativo:hover {
                        text-decoration: underline;
                        text-decoration-color: var(--warning);
                        text-underline-offset: 5px;
                        text-decoration-thickness: 2px;
                    }
                }
            }
        }
        .bloco-dados {
            margin: 0 8px;

            .bloco-interno {
                display: flex;
                align-items: baseline;
                height: 100%;
                font-weight: 600;
                padding-top: 5px;
                flex-wrap: wrap;

                span {
                    font-size: 22px;
                    color: #3b3b3b;
                    margin-right: 10px;
                }

                a {
                    margin-left: 10px;
                    cursor: pointer;
                    color: rgba(9, 111, 231, 1);
                    font-weight: 400;
                    font-family: Roboto;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .alerta-bloco--icone {
        background: var(--warning);
        width: 77px;
        height: 77px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: var(--white);
    }

    .ativo {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--warning);
        text-underline-offset: 5px;
        text-decoration-thickness: 2px;
    }
}
</style>
